'use strict';

export function restoreBackup({ ID, onSuccess, onFail} = {}){
    const postURL = '/components/backup.cfc?method=restoreBackupWeb';
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    return fetch(postURL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({
            'backupID': ID,
        }),
    })
        .then(response => {

            if (response.status === 200) {
                onSuccess();
                return null;
            } else {
                return response.json()
                    .then(errData => {
                        const msg = errData?.message || '';
                        onFail(msg);
                        return null;
                    })
                    .catch(() => {
                        onFail('Unable to restore backup. Please try again');
                        return null;
                    });
            }

        })
        .catch(error => {
            alert('Network error: Could not connect to the server.');
            console.error('Fetch failed:', error);
        });
}

export function deleteBackup({ ID, onSuccess, onFail} = {}){
    const postURL = '/components/backup.cfc?method=deleteUserBackupWeb';
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    return fetch(postURL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({
            'backupID': ID,
        }),
    })
        .then(response => {
            console.log('response!');
            if (response.status === 204) {
                onSuccess();
                return null;
            } else {
                return response.json()
                    .then(errData => {
                        const msg = errData?.message || '';
                        onFail(msg);
                        return null;
                    })
                    .catch(() => {
                        onFail('Unable to remove backup. Please try again');
                        return null;
                    });
            }

        })
        .catch(error => {
            alert('Network error: Could not connect to the server.');
            console.error('Fetch failed:', error);
        });
}

export async function createNewBackup({ backupName = '', onSuccess, onFail } = {}) {

    const postURL = '/components/backup.cfc?method=backupUserDatabaseWeb';
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    return fetch(postURL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({
            'backupName': backupName,
        }),
    })
        .then(response => {
            if (response.status === 201) {
                onSuccess();
                return null;
            } else {
                return response.json()
                    .then(errData => {
                        const msg = errData?.message || '';
                        onFail(msg);
                        return null;
                    })
                    .catch(() => {
                        onFail('Unable to create backup. Please try again');
                        return null;
                    });
            }

        })
        .catch(error => {
            alert('Network error: Could not connect to the server.');
            console.error('Fetch failed:', error);
        });
}

export function createBackupListGrid({
    dateDisplayFormat,
    gridContainer,
    startingRowNum = 10,
    onRestore,
    onDelete,
    showDbMeta} = {}){

    const grid = gridContainer.find('.mainGrid');
    const gridID = grid.attr('id');
    const gridPagerID = '#' + grid.data('pager-id');

    EQLAPP.COMMON.register({
        'gridID': gridID,
    });

    grid.jqGrid({
        url: '/components/backup.cfc?method=getBackupsWeb',
        datatype: 'json',
        colNames: [
            'ID',
            'Created At',
            'Name',
            'Size (MBs)',
            'Version',
            'Restore',
            'Remove',
        ],
        colModel: [
            {
                index: 'ID',
                name: 'ID',
                hidden: true,
            },
            {
                index: 'CreatedAt',
                name: 'CreatedAt',
                width: 154,
                sorttype: 'Date',
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: dateDisplayFormat,
                },
                align: 'center',
            },
            {
                index: 'FriendlyName',
                name: 'FriendlyName',
                sortable: true,
                sorttype: 'text',
                width: 343,
            },
            {
                index: 'SizeInMB',
                name: 'SizeInMB',
                sortable: true,
                sorttype: 'numeric',
                align: 'right',
                width: 80,
                hidden: !showDbMeta,
            },
            {
                index: 'SoftwareVersion',
                name: 'SoftwareVersion',
                sortable: true,
                sorttype: 'numeric',
                align: 'right',
                width: 80,
                hidden: !showDbMeta,
            },
            {
                name: 'edit',
                width: 54,
                align: 'center',
                sortable: false,
                classes: 'option databaseRestore pointer js-restore',
                hidden: false,
            },
            {
                name: 'delete',
                width: 54,
                align: 'center',
                sortable: false,
                classes: 'option remove pointer  js-remove',
            },
        ],
        rowNum: startingRowNum,
        rowList: [10,30,50],
        autowidth: true,
        height: '100%',
        pager: gridPagerID,
        sortname: 'CreatedAt',
        sortorder: 'DESC',
        loadComplete: function(){
            gridFix('#' + grid.attr('id'));
            //var recCount = $('#emailInquiryGridPager').find('.ui-pg-selbox').val();
            //setMiscSetting('pagination_email_inquiry_main',recCount);
        },
        onCellSelect: function (rowid, iCol, cellcontent, e) {
            var $cell = $(e.target);

            if ($cell.hasClass('js-restore')) {
                onRestore(rowid);
            }

            if ($cell.hasClass('js-remove')) {
                onDelete(rowid);
            }
        },
    });

    return grid;
}
